export const salt = 'f8a69f1719916z';
export const appKey = '4371533bed567a9273557a15c45edd85';
export const fpid = 193;
export const aid = 2939;
